import React from "react";
import IntlMessages from "@util/IntlMessages";
import GlobalSettings from "../GlobalSettings/GlobalSettingsModal";
import PercentageSummarySettings from "./PercentageSummarySettings";
import { Tabs } from "../../../BP2Components";
import TabPane from "../../../BP2Components/Tabs/TabPane";

const PercentageSummarySettingsModal = (props) => {
   return (
      <Tabs defaultActiveKey="1">
         <TabPane tab={<IntlMessages id="settings.globalSettings" />} key="1">
            <GlobalSettings {...props} />
         </TabPane>
         <TabPane tab={<IntlMessages id="settings.widgetSettings" />} key="2">
            <PercentageSummarySettings {...props} />
         </TabPane>
      </Tabs>
   );
};

export default PercentageSummarySettingsModal;
